import React from 'react';

interface PatientDiagnosisSvgIconProps {
  size?: number;
  color?: string;
}

/**
 * Custom Patient Diagnosis icon: clipboard with heartbeat ECG and stethoscope badge.
 * Matches the exact design from the reference image.
 */
const PatientDiagnosisSvgIcon: React.FC<PatientDiagnosisSvgIconProps> = ({
  size = 24,
  color = '#0077B6',
}) => {
  const secondaryColor = '#48CAE4';
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      width={size}
      height={size}
      fill="none"
    >
      {/* Clipboard Back */}
      <rect x="15" y="15" width="55" height="70" rx="4" ry="4" stroke={color} strokeWidth="4" fill="white" />
      
      {/* Top Clip */}
      <rect x="35" y="10" width="15" height="8" rx="2" ry="2" stroke={color} strokeWidth="4" fill="white" />
      <circle cx="42.5" cy="14" r="2" fill={color} />

      {/* Heartbeat / ECG Line */}
      <path 
        d="M25 40 L32 40 L35 32 L40 48 L43 40 L50 40" 
        stroke={color} 
        strokeWidth="3" 
        strokeLinecap="round" 
        strokeLinejoin="round" 
      />
      
      {/* Heart Icon near ECG */}
      <path 
        d="M37.5 35 C35.5 33 32.5 33 30.5 35 C28.5 37 28.5 40 30.5 42 L37.5 49 L44.5 42 C46.5 40 46.5 37 44.5 35 C42.5 33 39.5 33 37.5 35" 
        stroke={color} 
        strokeWidth="2" 
        fill={secondaryColor} 
        opacity="0.3"
      />

      {/* Checkboxes and lines */}
      <rect x="25" y="58" width="8" height="8" rx="1" stroke={color} strokeWidth="2.5" />
      <line x1="38" y1="62" x2="55" y2="62" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
      
      <rect x="25" y="72" width="8" height="8" rx="1" stroke={color} strokeWidth="2.5" />
      <line x1="38" y1="76" x2="50" y2="76" stroke={color} strokeWidth="2.5" strokeLinecap="round" />

      {/* Circle Badge with Stethoscope */}
      <circle cx="70" cy="70" r="22" fill="#E3F2FD" stroke={color} strokeWidth="4" />
      
      {/* Stethoscope Icon inside circle */}
      <g transform="translate(60, 60) scale(0.4)">
         {/* Head */}
         <circle cx="25" cy="40" r="8" stroke={color} strokeWidth="6" fill="white" />
         {/* Tubes */}
         <path 
            d="M25 32 Q25 15 10 15 M25 32 Q25 15 40 15" 
            stroke={color} 
            strokeWidth="6" 
            fill="none" 
            strokeLinecap="round" 
         />
         {/* Ear pieces */}
         <circle cx="10" cy="15" r="3" fill={color} />
         <circle cx="40" cy="15" r="3" fill={color} />
      </g>
    </svg>
  );
};

export default PatientDiagnosisSvgIcon;
